import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./assets/styles/style.css";

// Layout
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import ScrollToTop from "./Components/ScrollToTop";

// Pages
import Home from "./Pages/Home";
import ContactUs from "./Pages/ContactUs";
import AboutUs from "./Pages/AboutUs";
import Event from "./Pages/Event";
import Deities from "./Pages/Deities";
import Donation from "./Pages/Donation";
import ServiceDetails from "./Pages/ServiceDetails";
import Services from "./Pages/Services";
import EventDetails from "./Pages/EventDetails";
import DonationDemo from "./Pages/Demo";
import DonationSuccess from "./Pages/DonationSuccess";
import DonationCancel from "./Pages/DonationCancel";

function App() {
  const location = useLocation();
  
  // Define routes where header and footer should be hidden
  const hideHeaderFooterRoutes = ['/donation-success', '/donation-cancel'];
  const shouldHideHeaderFooter = hideHeaderFooterRoutes.includes(location.pathname);

  return (
    <div className="App">
      {!shouldHideHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/deities" element={<Deities />} />
        <Route path="/donation" element={<Donation />} />
        {/* <Route path="/donation-demo" element={<DonationDemo />} /> */}
        <Route path="/donation-success" element={<DonationSuccess />} />
        <Route path="/donation-cancel" element={<DonationCancel />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/event" element={<Event />} />
        <Route path="/event/:slug" element={<EventDetails />} />
        <Route path="/services" element={<Services />} />
        <Route path="/service/:slug" element={<ServiceDetails />} />
      </Routes>
      {!shouldHideHeaderFooter && <Footer />}
      <ScrollToTop />
    </div>
  );
}

export default App;